import React from 'react'
import ReactDOM from 'react-dom'
import Conversation from './Conversation'

document.addEventListener('turbo:load', () => {
  const conversationContainer = document.getElementById('conversationContainer')
  const conversation = window.conversation
  const can_update_conversation = window.can_update_conversation
  const current_user_id = window.current_user_id

  if (conversationContainer) {
    const conversation = JSON.parse(conversationContainer.dataset.conversation),
      canUpdateConversation = conversationContainer.dataset.canUpdateConversation,
      currentUserId = Number(conversationContainer.dataset.currentUserId)

    ReactDOM.render(
      <Conversation
        conversation={conversation}
        canUpdateConversation={canUpdateConversation}
        currentUserId={currentUserId}
      />,
      conversationContainer,
    );

    document.addEventListener('turbo:before-visit', () => {
      ReactDOM.unmountComponentAtNode(conversationContainer)
    })

    document.addEventListener('click', (e) => {
      if (document.querySelector('.edit') && !e.target.classList.contains('more')) {
        document.querySelector('.edit').classList.remove('edit')
      }
      if (document.querySelector('.room_actions')) {
        let alreadyOpen = document.querySelector('.room_actions').classList.contains('show')
        if (alreadyOpen && !e.target.classList.contains('chat_menu')) {
          document.querySelector('.room_actions').classList.remove('show')
        }
      }
    })

    document.querySelector('.messages_desktop').addEventListener("scroll", (event) => {
      let lastKnownScrollPosition = window.scrollY;
      let dateBage = document.querySelector('.current-date')
      let currentPosition = dateBage.getBoundingClientRect()
      let elementUnderBadge = document.elementFromPoint(currentPosition.x, currentPosition.y)
      if(elementUnderBadge && elementUnderBadge.classList.contains('element'))
      {
        console.log(elementUnderBadge)
        let currentDate = elementUnderBadge.querySelector('.created-at')
        dateBage.innerHTML = currentDate.innerHTML
      }
      // let currentDate = elementUnderBadge.parentElement.querySelector('.created-at')
      // if (currentDate) dateBage.innerHTML = currentDate.innerHTML
    })
  }
})